import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import UploadProps from './UploadProps'

import Async from './Async'
import Files from './Files'
import Localization from './Localization'
import Validation from './Validation'

export default {
    props: UploadProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Async,
        Files,
        Localization,
        Validation
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoUpload(this.widgetOptions)
        this.$_upload = this.kendoWidget()
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.$_upload)
        } else {
            this.$emit('kendowidgetready', this.$_upload)
        }
    },
    methods: {
        kendoWidget() {
            if(this.$el && this.$el.parentElement){
                return kendo.jQuery(this.$el).getKendoUpload()
            }

            return this.$_upload
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/KendoUploadMixin.js